import commonVariables from './commonVariables';
import { title } from "assets/jss/material-kit-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-kit-react/customCheckboxRadioSwitch.jsx";

var windowInnerHeight = typeof window !== `undefined` ? window.innerHeight : 0;
var windowInnerWidth = typeof window !== `undefined` ? window.innerWidth : 0;

const commonStyles = {
  ...customCheckboxRadioSwitch,
  main: {
    background: commonVariables.color.posBackground,
    position: 'fixed',
    zIndex: "3"
  },
  mainRaised: {
    marginTop: '0px',
    marginLeft: '0px',
    marginRight: '0px',
    //padding: '10px 10px 10px 10px',
    minHeight: windowInnerHeight,
    minWidth: windowInnerWidth,
    maxWidth: windowInnerWidth,
    borderRadius: "10px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },

  loading: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffffbb',
    zIndex: 999
  },
  loadingText: {
    fontWeight: "bold",
    fontSize: "2em",
    color: "#000",
  },
  activeButton: {
    backgroundColor: commonVariables.color.primary,
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.primary,
      color: '#fff'
    }
  },
  inActiveButton: {
    backgroundColor: commonVariables.color.gray,
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: commonVariables.color.primary,
    borderRadius: 10,
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.gray,
      color: '#fff'
    }
  },
  activeSimpleButton: {
    fontSize: '1.2em',
    color: commonVariables.color.primary,
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'none',
    "&:hover,&:focus": {
      color: commonVariables.color.primary
    }
  },
  normalSimpleButton: {
    fontSize: '1.2em',
    color: commonVariables.color.default,
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'none',
    "&:hover,&:focus": {
      color: commonVariables.color.default
    }
  },
  inActiveSimpleButton: {
    fontSize: '1.2em',
    color: commonVariables.color.gray,
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'none',
    "&:hover,&:focus": {
      color: commonVariables.color.gray
    }
  },
  
  alertButton: {
    backgroundColor: commonVariables.color.alert,
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.alert,
      color: '#fff',
      boxShadow: 'none'
    }
  },
  successButton: {
    backgroundColor: commonVariables.color.success,
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.success,
      color: '#fff',
      boxShadow: 'none'
    }
  },
  disabledButton: {
    backgroundColor: commonVariables.color.gray,
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.success,
      color: '#fff',
      boxShadow: 'none'
    }
  },
  normalButton: {
    backgroundColor: 'transparent',
    fontSize: '1.2em',
    color: '#000',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    "&:hover,&:focus": {
      backgroundColor: 'transparent',
      color: '#000',
      boxShadow: 'none'
    }
  },
  normalBorderButton: {
    backgroundColor: 'transparent',
    fontSize: '1.2em',
    color: '#000',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: commonVariables.color.primary,
    "&:hover,&:focus": {
      backgroundColor: 'transparent',
      color: '#000',
      boxShadow: 'none'
    }
  },

  whiteBorderButton: {
    backgroundColor: 'transparent',
    fontSize: '1.2em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#fff',
    "&:hover,&:focus": {
      backgroundColor: 'transparent',
      color: '#fff',
      boxShadow: 'none'
    }
  },

  redTextButton: {
    backgroundColor: '#fff',
    fontSize: '1.2em',
    color: '#f00',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    textTransform: 'capitalize',
    // borderStyle: 'solid',
    // borderWidth: 1,
    // borderColor: '#fff',
    "&:hover,&:focus": {
      backgroundColor: '#fff',
      color: '#f00',
      boxShadow: 'none'
    }
  },

  posButton: {
    backgroundColor: commonVariables.color.background,
    fontSize: '1em',
    color: '#000',
    fontFamily: "Avenir",
    fontWeight: 'bold',
    textTransform: 'capitalize',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: commonVariables.color.primary,
    borderRadius: 10,
    width: 66,
    height: 66,
    marginTop: 1,
    marginBottom: 1,
    marginLeft: 1,
    marginRight: 1,
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.background,
      color: '#000'
    }
  },

  posButtonSoldOut: {
    backgroundColor: commonVariables.color.gray,
    fontSize: '1em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'bold',
    textTransform: 'capitalize',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: commonVariables.color.primary,
    borderRadius: 10,
    width: 66,
    height: 66,
    marginTop: 1,
    marginBottom: 1,
    marginLeft: 1,
    marginRight: 1,
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.gray,
      color: '#fff'
    }
  },

  activeTapButton: {
    backgroundColor: commonVariables.color.background,
    fontSize: '0.7em',
    color: commonVariables.color.primary,
    fontFamily: "Avenir",
    fontWeight: 'normal',
    borderRadius: '10px 10px 0px 0px',
    textTransform: 'capitalize',
    margin: 0,
    borderBottomWidth: 0,
    borderBottomStyle: 'none',
    boxShadow: 'none',
    //padding: 0,
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.background,
      color: commonVariables.color.primary,
      boxShadow: 'none'
    }
  },
  inActiveTapButton: {
    backgroundColor: commonVariables.color.gray,
    fontSize: '0.7em',
    color: '#fff',
    fontFamily: "Avenir",
    fontWeight: 'normal',
    borderRadius: '10px 10px 0px 0px',
    textTransform: 'capitalize',
    margin: 0,
    borderBottomWidth: 0,
    borderBottomStyle: 'none',
    boxShadow: 'none',
    "&:hover,&:focus": {
      backgroundColor: commonVariables.color.gray,
      color: '#fff',
      boxShadow: 'none'
    }
  },

  alertDlgTitle : {
    fontWeight: "bold",
    fontSize: "1.5em",
    color: "#000",
    textAlign: 'center'
  },
  alertDlgBody : {
    fontWeight: "normal",
    fontSize: "1em",
    lineHeight: "2",
    color: "#000",
    textAlign: 'center',
    whiteSpace: 'pre'
  },

  largeDialogContainer: {
    width: 1080,
    maxWidth: 1080
  },

  section: {
    backgroundColor: "#FFFFFF",
    display: "block",
    width: "100%",
    position: "relative",
    padding: "0"
  },
  title: {
    ...title,
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },

  input: {
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: commonVariables.color.primary,
    borderRadius: 5,
    height: 40,
    color: commonVariables.color.primary,
    fontSize: '1em',
    "&:focus": {
      backgroundColor: '#0f05'
    },
  },

  verticalScrollBar: {
    "&::-webkit-scrollbar": {
      width: '25px'
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: '#d1d1d0',
      borderRadius: '0px',
      borderStyle: 'solid',
      borderWidth: '5px',
      borderTopWidth: '0px',
      borderBottomWidth: '0px',
      borderColor: commonVariables.color.background
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: '#7c7c7c', 
      borderRadius: '0px',
      borderStyle: 'solid',
      borderWidth: '5px',
      borderTopWidth: '0px',
      borderBottomWidth: '0px',
      borderColor: commonVariables.color.background
    },
    "&::-webkit-scrollbar-button:single-button": {
      minWidth: '25px',
      minHeight: '25px',
      backgroundColor: '#f47e30',
      borderRadius: '3px',
      display: 'block',
      backgroundSize:'10px',
      backgroundRepeat: 'no-repeat'
    },
    "&::-webkit-scrollbar-button:single-button:vertical:decrement": {
      height: '12px',
      width: '16px',
      backgroundPosition: 'center 10px',
      backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(255, 255, 255)'><polygon points='50,00 0,50 100,50'/></svg>")`
    },
    "&::-webkit-scrollbar-button:single-button:vertical:increment": {
        height: '12px',
        width: '16px',
        backgroundPosition: 'center 10px',
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(255, 255, 255)'><polygon points='0,0 100,0 50,50'/></svg>")`
    }
  },

  textEllipsis: {
    overflow: 'hidden',
    whiteSpace: 'nowrap', 
    textOverflow: 'ellipsis'
  }
};

export default commonStyles;
